import { differenceInMinutes } from "date-fns";

/**
 * Outputs duration between two dates in the format of "X hours YY minutes" or "YY minutes"
 * Examples: "8 hours 30 minutes", "1 hour 30 minutes", "45 minutes"
 * If showNegative is true, handles negative durations by showing negative hours
 */
export function formatDurationBetweenDates(params: {
  fromDate: Date;
  toDate: Date;
  abbreviate?: boolean;
  padMinutes?: boolean;
  showNegative?: boolean;
}): string {
  const { fromDate, toDate, abbreviate = false, padMinutes = true, showNegative = true } = params;

  const totalMinutes = differenceInMinutes(toDate, fromDate);
  const hours =
    Math.floor(Math.abs(totalMinutes) / 60) * (showNegative ? Math.sign(totalMinutes) : 1);
  const minutes = Math.abs(totalMinutes % 60);

  let hourUnit = "hours";
  if (Math.abs(hours) === 1) {
    hourUnit = "hour";
  }

  if (abbreviate) {
    hourUnit = Math.abs(hours) === 1 ? "hr" : "hrs";
  }

  let minuteUnit = minutes === 1 ? "minute" : "minutes";

  if (abbreviate) {
    minuteUnit = "min";
  }

  if (totalMinutes === 0) {
    return `0 ${minuteUnit}`;
  }

  if (hours !== 0) {
    const paddedMinutes = padMinutes ? minutes.toString().padStart(2, "0") : minutes.toString();
    return `${hours} ${hourUnit} ${paddedMinutes} ${minuteUnit}`;
  }

  const paddedMinutes = padMinutes ? minutes.toString().padStart(2, "0") : minutes.toString();
  return `${paddedMinutes} ${minuteUnit}`;
}
